/** Platform default branding — club-agnostic SmartTT look. */
export const DEFAULT_BRAND = {
  brand_name: "Smart TT",
  brand_short_name: "Smart TT",
  brand_tagline:
    "Train Smart\nEmpower your club, your coach, and your community—with SmartTT and you.",
  logo_url: null,
  logo_light_url: null,
  favicon_url: "/appicon.png",
  color_primary: "#0877BC",
  color_primary_dark: "#065a8f",
  color_primary_light: "#0a8cd8",
  color_secondary: "#46528b",
  color_accent: "#FFEFDD",
  color_background: "#f4f5f6",
  color_surface: "#FFFFFF",
  color_text_primary: "#1E1E1E",
  color_text_secondary: "#838383",
  font_family: "Poppins",
  show_ai_coach: true,
  show_powered_by: true,
  /** full | pilot — see Frontend pilotAdminNav.js */
  admin_feature_pack: "full",
  is_demo: false,
  default_language: "en",
  meta_description:
    "Train Smart TT—empower club, coach, and community. SmartTT-Club: AI insights for coaches. SmartTT-Player: sessions, peer challenges on registered clubs and tables, coach feedback on performance with AI support.",
  club_subdomain: null,
};

/** Keep in sync with Backend/src/constants/brandLangPalettes.js */
export const LANG_PALETTES = {
  en: {
    label: "English",
    color_primary: "#0877BC",
    color_primary_dark: "#065a8f",
    color_primary_light: "#0a8cd8",
    color_secondary: "#46528b",
    color_accent: "#FFEFDD",
  },
  fr: {
    label: "Français",
    color_primary: "#0055A4",
    color_primary_dark: "#003D77",
    color_primary_light: "#2A7AC4",
    color_secondary: "#1B365D",
    color_accent: "#F4E4D7",
  },
  de: {
    label: "Deutsch",
    color_primary: "#1A365D",
    color_primary_dark: "#0F2340",
    color_primary_light: "#2C5282",
    color_secondary: "#B8860B",
    color_accent: "#F5E6C8",
  },
  es: {
    label: "Español",
    color_primary: "#B91C1C",
    color_primary_dark: "#7F1212",
    color_primary_light: "#DC3B3B",
    color_secondary: "#1B365D",
    color_accent: "#F8E8C8",
  },
  nl: {
    label: "Nederlands",
    color_primary: "#C2410C",
    color_primary_dark: "#9A3309",
    color_primary_light: "#EA580C",
    color_secondary: "#1B365D",
    color_accent: "#FFE8D6",
  },
  pt: {
    label: "Português",
    color_primary: "#047857",
    color_primary_dark: "#065F46",
    color_primary_light: "#0F9F6E",
    color_secondary: "#9F1239",
    color_accent: "#E8F5EE",
  },
};

function hexEq(a, b) {
  return (
    String(a || "").replace("#", "").toUpperCase() ===
    String(b || "").replace("#", "").toUpperCase()
  );
}

export function isPlatformDefaultPalette(brand) {
  if (!brand) return true;
  return (
    hexEq(brand.color_primary, DEFAULT_BRAND.color_primary) &&
    hexEq(
      brand.color_secondary || DEFAULT_BRAND.color_secondary,
      DEFAULT_BRAND.color_secondary
    )
  );
}

export function brandDefaultsForLang(lang) {
  const code = String(lang || "en").substring(0, 2).toLowerCase();
  const palette = LANG_PALETTES[code] || LANG_PALETTES.en;
  return {
    ...DEFAULT_BRAND,
    color_primary: palette.color_primary,
    color_primary_dark: palette.color_primary_dark,
    color_primary_light: palette.color_primary_light,
    color_secondary: palette.color_secondary,
    color_accent: palette.color_accent,
    default_language: LANG_PALETTES[code] ? code : "en",
  };
}

export function applyCountryLangBrandDefaults(brand, lang) {
  if (!isPlatformDefaultPalette(brand)) return brand;
  if (brand?.logo_url && brand.logo_url !== DEFAULT_BRAND.logo_url) return brand;
  const defaults = brandDefaultsForLang(lang);
  return {
    ...brand,
    color_primary: defaults.color_primary,
    color_primary_dark: defaults.color_primary_dark,
    color_primary_light: defaults.color_primary_light,
    color_secondary: defaults.color_secondary,
    color_accent: defaults.color_accent,
    default_language:
      brand?.default_language && brand.default_language !== "en"
        ? brand.default_language
        : defaults.default_language,
  };
}
